export default __webpack_public_path__ + "static/media/something-went-wrong-mobile.bf3fc057.png";